export default "__VITE_ASSET__BTxEiP9X__"